/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import cx from 'classnames';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Card, Tooltip, Typography } from '@mui/material';

import { Namespaces } from '../../../../i18n';
import { useControlOverlays } from '../../../../utils/useControlOverlays';
import { useServiceCardNewStyles } from './ServiceCardNew.styles';

type ServiceCardNewProps = {
  disabled?: boolean;
};

export const ServiceCardNew = memo<ServiceCardNewProps>(props => {
  const { t } = useTranslation(Namespaces.Entities);

  const { disabled = false } = props;

  const classes = useServiceCardNewStyles();

  const { doOpenCreateServiceOverlay } = useControlOverlays();

  return (
    <Card
      elevation={2}
      className={cx(classes.card, {
        [classes.cardDisabled]: disabled,
      })}
    >
      <Tooltip title={disabled ? t('cluster.not_allowed') : ''}>
        <Box
          onClick={() => !disabled && doOpenCreateServiceOverlay()}
          className={classes.root}
          aria-disabled={disabled}
          data-cy={`new-entity-${t('cluster.create_service')}`}
        >
          <Typography
            variant="h4"
            component="div"
            className={cx(classes.cardTitle, {
              [classes.cardTitleDisabled]: disabled,
            })}
          >
            +&nbsp;{t('cluster.create_service')}
          </Typography>
        </Box>
      </Tooltip>
    </Card>
  );
});
